import LazyAreanameSelector from "./lazy-areaname-selecter.component";

export default LazyAreanameSelector;
